import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs';

import { selectTheme } from '@core/stores/auth/auth.selectors';

export const themeCanActivateGuard: CanActivateFn = () => {
  const store = inject(Store);

  return store.select(selectTheme).pipe(
    filter((theme) => !!theme),
    map(() => true)
  );
};
